import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from 'react-router-dom';
import "./NoticiaDetail.css";


const NoticiaDetail = () => {
    const { id } = useParams();

  const [noticia, setNoticia] = useState(null);

  useEffect(() => {
    const fetchNoticia = async () => {
      try {
        const response = await axios.get(`https://us-central1-inprojuy-f1173.cloudfunctions.net/app/noticias/${id}`);
        setNoticia(response.data);
      } catch (error) {
        console.error("Error fetching noticia:", error);
      }
    };

    fetchNoticia();
  }, [id]);

  if (!noticia) {
    return <div>Loading...</div>;
  }
console.log(noticia.titulo)
  return (
    <div className="noticia-detail">
      <div className="noticia-detail__container">
        <h1 className="noticia-detail__title botonbordeazul text-white">{noticia.titulo}</h1>
        <div className="noticia-detail__image">
          <img
            className="img-fluid foto"
            src={noticia.imagenUrl}
            alt={noticia.nombreimagen || noticia.titulo}
          />
        </div>
        <div
          className="noticia-detail__content"
          dangerouslySetInnerHTML={{ __html: noticia.contenido }}
        />
      </div>
    </div>
  );
};

export default NoticiaDetail;
